import { Stack } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { PageContent, PageLayout } from '../../layout';
import { UserAuthCard } from './modules/UserAuthCard';
import { UserCookieSettings } from './modules/UserCookieSettings';
import { UserEditCard } from './modules/UserEditCard';

const TRANS_NS = 'page-user-profile';

export const UserProfile = () => {
  const { t } = useTranslation(TRANS_NS);

  return (
    <>
      <PageLayout>
        <PageHeader backRouteTo={null} title={t('title')} />
        <PageContent sx={{ alignItems: 'flex-start', flexWrap: 'wrap' }}>
          <Grid2 container spacing={4}>
            <Grid2 xs={12} md={8}>
              <UserEditCard />
            </Grid2>
            <Grid2 xs={12} md={4}>
              <Stack gap={4}>
                <UserAuthCard />
                <UserCookieSettings />
              </Stack>
            </Grid2>
          </Grid2>
        </PageContent>
      </PageLayout>
      <Outlet />
    </>
  );
};
